import React from "react";

function Ryan() {
  return (
    <div>
      <p className="employee_title">
        Business Systems Developer and Administrator <br />
      </p>

      <p className="post__text">
        Ryan joined Lifetime Capital in 2023 with a mission to transform the
        firm’s operations and technology into a streamlined, scalable engine
        that elevates the experience of everyone the firm serves. With a
        background shaped by years as a UX/UI Designer for leading technology
        companies—including Google, Facebook, Apple, and Lam Research—he brings
        a rare blend of technical expertise and humancentered design to the
        financial services industry.
      </p>
      <p className="post__text">
        As Salesforce Administrator and Operations Systems Manager, Ryan built
        Lifetime Capital’s Salesforce Financial Services Cloud (FSC) platform
        from the ground up. He introduced automation, AIdriven tools, and
        intuitive workflows that significantly reduced manual tasks, improved
        data accuracy, and created a more efficient, consistent operational
        rhythm across the firm. These enhancements give Lifetime Capital greater
        visibility, faster access to information, and the ability to deliver a
        more proactive, personalized experience to clients.
      </p>
      <p className="post__text">
        Beyond Salesforce, Ryan modernized the firm’s archiving and reporting
        systems, eliminated operational bottlenecks, and integrated previously
        disconnected tools into a unified ecosystem. These improvements
        strengthened internal collaboration, increased efficiency, and created a
        smoother, more responsive experience for both the team and the clients
        they support.
      </p>
      <p className="post__text">
        Today, Ryan’s work forms the backbone of a cohesive, futureready
        operational infrastructure—one that supports Lifetime Capital’s longterm
        growth and empowers the entire firm to serve clients with greater
        clarity, speed, and confidence.
      </p>
    </div>
  );
}
export default Ryan;
